import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RevertSecondFactorComponent } from './revert-second-factor.component';

@NgModule({
  declarations: [
    RevertSecondFactorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    RevertSecondFactorComponent
  ]
})
export class RevertSecondFactorModule { }
